import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionReadyToSharePostByIdQuery,
	PetitionReadyToSharePostByIdQueryVariables,
} from './getPetitionReadyToSharePostById.graphql';
import { PetitionReadyToSharePostById } from './getPetitionReadyToSharePostById.graphql';

export type ReadyToSharePost = Extract<
	PetitionReadyToSharePostByIdQuery['petitionReadyToSharePost'],
	{ __typename: 'ReadyToSharePost' }
>;
export type PreviewLinkImage = ReadyToSharePost['images'][number];

export async function getPetitionReadyToSharePostById(
	slugOrId: string,
	{ gql: { fetch } }: UtilityContext,
	readyToShareId: string,
): Promise<ReadyToSharePost | null> {
	const { data } = await fetch<PetitionReadyToSharePostByIdQuery, PetitionReadyToSharePostByIdQueryVariables>({
		query: PetitionReadyToSharePostById,
		variables: { slugOrId, readyToShareId },
		rejectOnError: true,
	});

	if (data.petitionReadyToSharePost.__typename === 'ReadyToSharePost') {
		return data.petitionReadyToSharePost;
	}

	return null;
}
